import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class EpicPageLegendCard extends Vue {
    @Prop({ default: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/card-logo.png' })
    public logoUrl!: string;

    @Prop({ default: 'RIFO is the leading O2O mobile ecological property trading platform in North America.' })
    public paragraph!: string;

}
